import Vue from 'vue'
import Vuex from 'vuex'
import router from '../src/router'

Vue.use(Vuex)

let baseURL = ''
let root = ''
let home = ''
let v = '/v1'
let nickname = ''
let avatarUrl = ''

switch (process.env.NODE_ENV) {
  case 'development':
    // root = home = 'http://127.0.0.1:9701' // 测试服
    root = home = 'https://www.gzgcs.cn' // 正式服
    baseURL = root + v
    break
  case 'production':
    root = home = 'https://www.gzgcs.cn' // 正式服
    baseURL = root + v
    break
}

export default new Vuex.Store({
  state: {
    apiBaseUrl: baseURL,
    nickname,
    avatarUrl,
    home: home,
    root: root,
    router
  },
  mutations: {},
  actions: {},
  modules: {}
})



//////////////////
// WEBPACK FOOTER
// ./store/index.js
// module id = vdRI
// module chunks = 7